import axios from 'axios';

export default (id) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .delete(`${process.env.VUE_APP_API_ADMIN_LOCATION}discount-package-tiers/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
